import { useEffect, useState } from 'react';
import { useSessionStorage } from 'react-use';
import { isUserLoggedIn } from '@noths/polaris-client-user-configuration';

export const AUTHENTICATION_STORAGE_KEY = 'CLIENT_SITE_CHROME__USER_AUTHENTICATED';

export const useAuthentication = () => {
  const [userAuthenticated, setUserAuthenticated] = useState<boolean | null>(null);
  const [cachedUserAuthenticated, setCachedUserAuthenticated] = useSessionStorage<boolean | null>(
    AUTHENTICATION_STORAGE_KEY,
    userAuthenticated,
  );

  useEffect(() => {
    setUserAuthenticated(cachedUserAuthenticated);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let cancelled = false;
    async function getAuthentication() {
      const newValue = await isUserLoggedIn();
      if (!cancelled) {
        setUserAuthenticated(newValue);
        setCachedUserAuthenticated(newValue);
      }
    }

    getAuthentication();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return userAuthenticated;
};
